import { faMegaphone } from '@fortawesome/pro-duotone-svg-icons';
import { IconButton, Tooltip } from "@mui/material";
import * as Sentry from "@sentry/react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";

const ToggleFeedbackButton = () => {
    const [feedback, _setFeedback] = useState(() => Sentry.getFeedback());

    const buttonRef = useRef<HTMLAnchorElement>();

    useEffect(() => {
        if (buttonRef.current) {
            const unsubscribe = feedback?.attachTo(
                buttonRef.current, 
                { 
                    colorScheme: 'light'
                }
            );

            return () => {
                unsubscribe?.()
            }
        }
    }, [buttonRef]);

    return (
        <Tooltip 
            title="Report a Bug"
        >
            <IconButton
                aria-label="theme"
                color="inherit"
                ref={buttonRef as any}
            >
                <FontAwesomeIcon icon={faMegaphone} fixedWidth />
            </IconButton>
        </Tooltip>
    );
}

export default ToggleFeedbackButton;